import {
  createColumnHelper,
  type PaginationState,
} from '@tanstack/react-table';
import { useState } from 'react';

import {
  type RecentattendanceRecord,
  useGetClassAnalytics,
} from '~entities/classes/api/class-analytics';

import { EnrollioTable } from '~shared/components/enrollio-table';
import { DataTableColumnHeader } from '~shared/components/table';
import { getStoredPageSize } from '~shared/helpers/page-size-preference';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

const columnHelper = createColumnHelper<RecentattendanceRecord>();

const columns = [
  columnHelper.accessor('date', {
    header: (info) => {
      return <DataTableColumnHeader column={info.column} title='Date' />;
    },
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor('studentPresent', {
    header: (info) => {
      return (
        <DataTableColumnHeader column={info.column} title='Students Present' />
      );
    },
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor('attendanceRate', {
    header: (info) => {
      return (
        <DataTableColumnHeader column={info.column} title='Attendance Rate' />
      );
    },
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];

export interface AttendanceTabProps {
  classId: string;
}

export const AttendanceTab = ({ classId }: AttendanceTabProps) => {
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: getStoredPageSize(),
  });
  const { data, isLoading } = useGetClassAnalytics({
    enrollmentId: classId,
    page: pagination.pageIndex + 1,
    limit: pagination.pageSize,
  });

  if (isLoading) return <div>Loading...</div>;

  const tableData = data?.resData.RecentattendanceRecords ?? [];
  const rowCount = data?.resData.pagination.totalItems;

  // if (!tableData.length) return <div>No data</div>;

  return (
    <Card>
      <CardHeader className='p-2 sm:p-6'>
        <CardTitle>Recent Attendance Records</CardTitle>
      </CardHeader>
      <CardContent className='p-2 sm:p-6'>
        <EnrollioTable
          ariaLabel='Recent attendance records'
          totalLabel='Attendance Records'
          columns={columns}
          data={tableData}
          isUpdating={isLoading}
          rowCount={rowCount}
          manualPagination
          pagination={pagination}
          onPaginationChange={setPagination}
        />
      </CardContent>
    </Card>
  );
};
